import type { IDistrictSchoolListItem } from "@/providers/store/api/districts/districts.interface";

export type SchoolSelectValueKey = "id" | "internalId";

export function getDistrictSchoolSelectValue(
  school: Pick<IDistrictSchoolListItem, "id" | "internalId">,
  valueKey: SchoolSelectValueKey,
): string {
  if (valueKey === "id") {
    return school.id;
  }

  return school.internalId ?? "";
}
